export default __webpack_public_path__ + "static/media/a011-08.68eef783.jpg";